module.exports = __webpack_public_path__ + "static/media/creditcardbenefits.f086dc26.svg";